import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { CustomSnackbarComponent } from 'shared/components/molecules';

interface NotificationDefaults {
  duration: number;
  horizontal: MatSnackBarHorizontalPosition;
  vertical: MatSnackBarVerticalPosition;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly snackBar = inject(MatSnackBar);
  private readonly translateSvc = inject(TranslateService);

  private readonly defaults: NotificationDefaults = {
    duration: 5000,
    horizontal: 'center',
    vertical: 'top',
  };

  public success(message: string, duration: number = this.defaults.duration, hideActions?: boolean): void {
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: {
        message: message,
        infoIcon: false,
        hideActions: hideActions,
      },
      duration: duration,
      panelClass: ['success-snackbar'],
      horizontalPosition: this.defaults.horizontal,
      verticalPosition: this.defaults.vertical,
    });
  }

  public info(message: string, duration: number = this.defaults.duration, hideActions?: boolean): void {
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: {
        message: message,
        infoIcon: false,
        hideActions: hideActions,
      },
      duration: duration,
      panelClass: ['info-snackbar'],
      horizontalPosition: this.defaults.horizontal,
      verticalPosition: this.defaults.vertical,
    });
  }

  public error(error: string | string[], duration: number = this.defaults.duration, hideActions?: boolean): void {
    let localisedText = '';
    if (Array.isArray(error)) {
      const localisedErrors = error.map((errorCode) => this.translateSvc.instant(errorCode));
      localisedText = localisedErrors.join('\n\n');
    } else {
      localisedText = this.translateSvc.instant(error);
    }
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: {
        message: localisedText,
        infoIcon: false,
        hideActions: hideActions,
      },
      duration: duration,
      panelClass: ['error-snackbar'],
      horizontalPosition: this.defaults.horizontal,
      verticalPosition: this.defaults.vertical,
    });
  }
}
